export default __webpack_public_path__ + "static/media/daily-pause-options-image.491aaa41.svg";